import { useMutation, useQuery } from 'react-query';
import { queryCreate, queryGet } from './fetch';

export interface ApplicationAnalytics {
  sessionId: string;
  sessionLinkId?: string;
  step: string;
  fieldId?: string;
  source?: string;
  date: Date;
  count: number;
}

interface TrackDto {
  step: string;
  fieldId?: string;
  sessionLinkId?: string;
  source?: string;
}

export const orderedApplicationSteps = [
  'home',
  'screening',
  'profile',
  'personal',
  'participation-rules',
  'applied',
  'add-to-panel',
  'update-profile',
];

export const useTrackApplicationAnalytics = (sessionId?: string) => {
  return useMutation<ApplicationAnalytics, Error, TrackDto>(
    queryCreate(`/sessions/${sessionId}/application-analytics/track`),
  );
};

export const useApplicationAnalytics = (sessionId: string) => {
  return useQuery<ApplicationAnalytics[]>(
    ['sessions', sessionId, 'application-analytics'],
    queryGet(`/sessions/${sessionId}/application-analytics`),
  );
};
